import { BaseEntity, MemoizeGetters } from './base';

@MemoizeGetters
export class ServiceModel extends BaseEntity {
  name?: string;
  description?: string;
  price?: number;
  perGallonDiscount?: number;
  title?: string;
  provider?: boolean;
  serviceType: ServiceType;
  inspectionFormUrl: string;

  get technicianTitle() {
    const techName = {
      [ServiceName.Wash]: 'wash team',
      [ServiceName.Detail]: 'detail team',
      [ServiceName.OilChange]: 'oil change mechanic',
      [ServiceName.Inspection]: 'inspector',
    }[this.serviceType.name];
    return techName || 'field tech';
  }

  get isInspection() {
    return this.serviceType.name === ServiceName.Inspection;
  }

  get promptForCustomerNote() {
    return !this.isInspection;
  }
}

export class ServiceType extends BaseEntity {
  id: string;
  name: ServiceName;
  uid: string;
  title: string;
}

export enum ServiceName {
  Wash = 'wash',
  RainX = 'rain_x',
  Tires = 'tires',
  OilChange = 'oil_change',
  Detail = 'detail',
  FuelAdditive = 'fuel_additive',
  WiperFluid = 'wiper_fluid',
  WiperBlades = 'wiper_blades',
  Polish = 'polish',
  RepairShop = 'repair_shop',
  Checkup = 'checkup',
  Health = 'health',
  EVCharging = 'ev_charging',
  Inspection = 'inspection',
}



// WEBPACK FOOTER //
// ./src/models/service.ts